//@flow
import _, { isBoolean } from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import withAbility from '../../hoc/withAbility';
import { produtoBloqueadoService } from '../../services/produtoBloqueado.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import ProdutoBloqueadoCrudListFilter from './ProdutoBloqueadoCrudListFilter';

const endPoint = '/produtoBloqueado/novo/';
const endPointView = '/produtoBloqueado/';
class ProdutoBloqueadoCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    const isSudo = props.user && props.user.perfis.includes('SUDO');

    this.columns = [
      {
        path: 'id',
        title: 'Identificador',
        isKey: true,
        dataSort: false,
        className: 'txtBold',
        hidden: true,
      },
      {
        path: 'produto.codigoProduto',
        title: 'Código produto',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
        width: '200px',
      },
      {
        path: 'produto.descricao',
        title: 'Produto',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
      },
      ...(isSudo
        ? [
            {
              path: 'nomeFantasia',
              title: 'Cliente',
              isKey: false,
              dataSort: false,
            },
          ]
        : []),

      {
        path: 'nomesPontosAtendimento',
        title: 'Pontos de Atendimento',
        isKey: false,
        dataSort: false,
      },
    ];

    const fields = this.columns.map((col) => col.path);
    const labels = this.columns.map((col) => col.title);

    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    if (this.props.ability.can('update', 'ProdutoBloqueado')) {
      this.props.history.push(endPointView + row.id);
    }
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };
  render() {
    const fields = this.state.fields;

    const tableColumn = _.map(this.columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Bloqueio de Produtos"
          subTitle=" "
          canBack={false}
        />
        <ListagemPage
          newButtonActionClick={() => {
            this.props.history.push('/produtoBloqueado/novo');
          }}
          delete={() => {}}
          service={produtoBloqueadoService}
          showNewButton={this.props.ability.can('create', 'ProdutoBloqueado')}
          labelNewButton="Novo Produto bloqueado"
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={ProdutoBloqueadoCrudListFilter}
          fields={fields}
          array={'produtoBloqueado'}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(withAbility(ProdutoBloqueadoCrudList));
